import styled from 'styled-components';

import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import NukaCarousel from '@r1-frontend/ui-react/components/NukaCarousel';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const breakpoints = {
    desktop: '1559px',
    sDesktop: '1280px',
    tablet: '1024px',
    mobile: '760px',
    sMobile: '535px',
    phone: '375px',
};

export const AddressLayout = styled.div`
    margin-bottom: -50px;
    width: 100%;
    background-color: #E5E5E5;
`;

export const InnerContainer = styled(GridContainer)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 1360px;
    margin: 0 auto;
    padding: 0;

    @media (max-width: ${breakpoints.desktop}) {
        width: 88%;
    }

    @media (max-width: ${breakpoints.sDesktop}) {
        width: 96%;
    }

    @media (max-width: ${breakpoints.tablet}) {
        width: 94%;
    }

    @media (max-width: ${breakpoints.mobile}) {
        width: 96%;
    }
`;

export const AddressCardBlock = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 64px;

    @media (max-width: ${breakpoints.tablet}) { 
        width: 100%;
        margin-bottom: 46px;
        display: flex;
    }

    @media (max-width:  ${breakpoints.mobile}) { 
        display: none;
    }

    @media (max-width: ${breakpoints.sMobile}) { 
        display: block;
    }
`;

export const CustomSwiper = styled(NukaCarousel)`
    padding-left: 0 !important;
    padding-right: 0 !important;
    display: none;
    
    & section,
    & div {
        outline: none;
    }

    & > section > div.slider-frame {
        padding: 24px 0 !important;
    }

    @media (max-width: ${breakpoints.tablet}) { 
        display: none;
    }

    @media (max-width: ${breakpoints.mobile}) { 
        display: block;
        margin-bottom: 20px;
    }

    @media (max-width: ${breakpoints.sMobile}) { 
        display: none;
    }
`;

export const CheckAdressBlock = styled.div`
    margin-bottom: 64px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;

    @media (max-width: ${breakpoints.tablet}) {
        display: block;
        margin-bottom: 46px;
    }
`;

export const FormTitle = styled.h1`
    width: 100%;
    ${FONTS.H1};

    @media screen and (max-width: ${breakpoints.sDesktop}) {
        margin-top: 81px;
    }

    @media screen and (max-width: ${breakpoints.tablet}) {
        margin-top: 40px;
        margin-bottom: 34px;
        ${FONTS.H2};
    }

    @media screen and (max-width: ${breakpoints.mobile}) {
        ${FONTS.H3};
    }    
`;

export const FormSubTitle = styled.h2`
    width: 100%;
    ${FONTS.H2};
    margin-bottom: 24px;

    @media screen and (max-width: ${breakpoints.tablet}) {
        ${FONTS.H3};
    }    
`;


export const FormDescTitle = styled.h2`
    width: 100%;
    ${FONTS.H2};
    margin-bottom: 14px;

    @media screen and (max-width: ${breakpoints.tablet}) {
        ${FONTS.H3};
    }    
`;

export const AddressCardText = styled.div`
    display: block;
    max-width: 1018px;
    width: 100%;
    margin-bottom: 128px;
`;

export const Description = styled.div`
    font-size: 18px;
    line-height: 28px;

    @media screen and (max-width: ${breakpoints.tablet}) {
        font-size: 16px;
        line-height: 24px;
    }    
`;
